module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-md-4",
    on: {
      "click": _vm.switchItem
    }
  }, [_c('div', {
    staticClass: "item-card"
  }, [_c('div', {
    staticClass: "card-block"
  }, [_c('h4', {
    staticClass: "card-title"
  }, [_vm._v(_vm._s(_vm.item.name))]), _vm._v(" "), _vm._l((_vm.item), function(value, key, index) {
    return _c('div', [(index < 5) ? _c('div', [_c('strong', [_vm._v(_vm._s(key))]), _vm._v(":" + _vm._s(value) + "\n        ")]) : _vm._e()])
  })], 2)])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-8b00defa","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Item.vue
// module id = 11
// module chunks = 0